/** @file Curve-graph key bindings, context `curves` (pushed while the graph canvas has focus). */
import type { Binding } from '@pose2d/shortcuts/types';

/** Escape drops a handle drag or box without committing; F frames every shown curve. */
export const bindings: Binding[] = [
  { id: 'curves.cancelGesture', keys: 'Escape', context: 'curves' },
  { id: 'curves.frameAll', keys: 'KeyF', context: 'curves' },
];
